<template>
  <div class="container">
    <back-button style="margin-top: 3rem;"></back-button>

    <div class="logo-container" style="text-align: center;">
      <img
        src="https://static.wixstatic.com/media/d4e936_e390f80c181c49f7bc028d267d97820c~mv2.png"
        alt="Logo"
        class="logo"
        style="max-width: 150px; margin-bottom: 30px;"
      />
    </div>

    <div class="header">
      <h1>{{ $t("tools.simulatorTitle") }}</h1>
      <p
        style="text-align: center; color: #666; font-style: italic; margin-top: -10px; margin-bottom: 25px;"
      >
        {{ $t("tools.simulatorDisclaimer") }}
      </p>
    </div>

    <simulador-tabs :activeTab.sync="activeTab"></simulador-tabs>

    <div class="calculator-container">
      <!-- Seção para Condomínio -->
      <div
        class="calculator-section"
        :class="{ active: activeTab === 'condominio' }"
      >
        <entorno-condominio
          v-model="condominio.entorno"
          @total-atualizado="updateTotalPessoas"
        ></entorno-condominio>
      </div>

      <!-- Seção para Empresa -->
      <div
        class="calculator-section"
        :class="{ active: activeTab === 'empresa' }"
      >
        <entorno-empresa
          v-model="empresa.entorno"
          @total-atualizado="updateTotalPessoas"
        ></entorno-empresa>
      </div>

      <!-- Blocos comuns para ambas as calculadoras -->
      <div class="common-blocks">
        <capacidade-faturamento
          v-model="dados.capacidadeFaturamento"
          :totalPessoas="totalPessoas"
          :capacidadeMaxima="capacidadeMaxima"
          :frequenciaMensal="frequenciaMensal"
          :ticketMedio="ticketMedio"
          @update:numero-alcancavel="updateNumeroAlcancavel"
          @update:valor-por-cliente="updateValorPorCliente"
          @faturamento-atualizado="updateFaturamentoPotencial"
          ref="capacidadeFaturamento"
        ></capacidade-faturamento>

        <analise-conservadora
          v-model="dados.analiseConservadora"
          :faturamentoPotencial="faturamentoPotencialValor"
          @faturamento-conservador-atualizado="updateFaturamentoConservador"
          ref="analiseConservadora"
        ></analise-conservadora>

        <despesas
          v-model="dados.despesas"
          :faturamentoConservador="faturamentoConservadorValor"
          @despesas-fixas-atualizado="updateDespesasFixas"
          @percentual-despesas-atualizado="updatePercentualDespesas"
        ></despesas>

        <contas-variaveis
          v-model="dados.contasVariaveis"
          :percentualDespesas="percentualDespesasValor"
          @total-contas-variaveis-atualizado="updateTotalContasVariaveis"
        ></contas-variaveis>

        <analise-viabilidade
          v-model="dados.analiseViabilidade"
          :faturamentoConservador="faturamentoConservadorValor"
          :totalContasVariaveis="totalContasVariaveisValor"
          :totalContasFixas="totalContasFixasValor"
          :valorInvestimento="valorInvestimentoValor"
          @percentual-lucro-atualizado="updatePercentualLucro"
          @lucro-projetado-atualizado="updateLucroProjetado"
          ref="analiseViabilidade"
        ></analise-viabilidade>

        <investimento
          v-model="dados.investimento"
          :lucroProjetado="lucroProjetadoValor"
          @investimento-atualizado="updateInvestimentoNecessario"
          ref="investimento"
        ></investimento>
      </div>
    </div>

    <!-- <app-footer></app-footer> -->
  </div>
</template>

<script>
// import AppFooter from '@/components/AppFooter.vue'
import BackButton from "@/components/ferramentas/BackButton.vue";
import SimuladorTabs from "@/components/ferramentas/simulador/SimuladorTabs.vue";
import EntornoCondominio from "@/components/ferramentas/simulador/EntornoCondominio.vue";
import EntornoEmpresa from "@/components/ferramentas/simulador/EntornoEmpresa.vue";
import CapacidadeFaturamento from "@/components/ferramentas/simulador/CapacidadeFaturamento.vue";
import AnaliseConservadora from "@/components/ferramentas/simulador/AnaliseConservadora.vue";
import Despesas from "@/components/ferramentas/simulador/Despesas.vue";
import ContasVariaveis from "@/components/ferramentas/simulador/ContasVariaveis.vue";
import AnaliseViabilidade from "@/components/ferramentas/simulador/AnaliseViabilidade.vue";
import Investimento from "@/components/ferramentas/simulador/Investimento.vue";

export default {
  name: "Simulador",
  components: {
    // AppFooter,
    BackButton,
    SimuladorTabs,
    EntornoCondominio,
    EntornoEmpresa,
    CapacidadeFaturamento,
    AnaliseConservadora,
    Despesas,
    ContasVariaveis,
    AnaliseViabilidade,
    Investimento
  },
  computed: {
    lucroProjetadoValor() {
      return this.lucroProjetado;
    }
  },
  data() {
    return {
      activeTab: "condominio",
      totalPessoas: 600,
      faturamentoPotencialValor: 0,
      faturamentoConservadorValor: 0,
      percentualDespesasValor: 0,
      totalContasVariaveisValor: 48.49,
      totalContasFixasValor: 0,
      valorInvestimentoValor: 0,
      percentualLucro: 0,
      lucroProjetado: 0,
      viabilidade: "INDEFINIDA",

      condominio: {
        entorno: {
          quantidadeApartamentos: 200,
          mediaMoradores: 3,
          totalMoradores: 600
        }
      },

      empresa: {
        entorno: {
          numeroFuncionarios: 450,
          totalPessoas: 450
        }
      },

      dados: {
        capacidadeFaturamento: {
          capacidadeMaxima: 70,
          numeroAlcancavel: 420,
          frequenciaMensal: 4,
          ticketMedio: 20.0,
          valorPorCliente: "80,00",
          faturamentoPotencial: "33.600,00"
        },

        analiseConservadora: {
          porcentagemMeta: 50,
          faturamentoConservador: "16.800,00"
        },

        despesas: {
          energia: 800.0,
          internet: 100.0,
          contador: 250.0,
          sistemaOnii: 250.0,
          conexaoMaquininha: 99.0,
          aluguel: 500.0,
          logistica: 100.0,
          outros: 0.0,
          totalDespesasFixas: "2.099,00",
          percentualDespesas: "12,49%"
        },

        contasVariaveis: {
          royaltiesFinanceiro: 10,
          imposto: 6,
          repasse: 0,
          lucro: 20,
          despesasRepresentadasVariavel: "12,49%",
          totalContasVariaveis: "48,49%"
        },

        analiseViabilidade: {
          margemContribuicao: "48,49%",
          margemContribuicaoMinima: "51,51%",
          lucroProjetado: "41.612,80"
        },

        investimento: {
          tempoRetornoInvestimento: 12,
          investimentoNecessario: "499.353,60"
        }
      }
    };
  },
  methods: {
    updateTotalPessoas(total) {
      console.log(`[Simulador] Total de pessoas atualizado para: ${total}`);
      this.totalPessoas = total;

      // Forçar atualização de componentes que dependem deste valor
      this.$nextTick(() => {
        // Verificar se há algum componente CapacidadeFaturamento na página
        const capacidadeComponents = this.$children.filter(
          c => c.$options.name === "CapacidadeFaturamento"
        );
        if (capacidadeComponents.length > 0) {
          console.log(`[Simulador] Forçando recálculo do número alcançável`);
          capacidadeComponents.forEach(c => c.calcularNumeroAlcancavel());
        }
      });
    },
    updateFaturamentoPotencial(valor) {
      console.log(
        `[Simulador] Recebendo faturamento potencial: ${valor} (${typeof valor})`
      );

      // Garantir que estamos trabalhando com um número para cálculos
      if (typeof valor === "number") {
        console.log(`[Simulador] Valor é um número. Armazenando diretamente.`);
        this.faturamentoPotencialValor = valor;
      } else if (typeof valor === "string") {
        console.log(`[Simulador] Valor é uma string: "${valor}"`);

        // Remover formatação e converter para número
        const valorLimpo = valor
          .replace(/[^\d.,]/g, "")
          .replace(".", "")
          .replace(",", ".");
        const valorNumerico = parseFloat(valorLimpo);

        console.log(
          `[Simulador] String limpa: "${valorLimpo}", Convertido para número: ${valorNumerico}`
        );

        if (!isNaN(valorNumerico)) {
          this.faturamentoPotencialValor = valorNumerico;
        } else {
          console.warn(
            `[Simulador] Não foi possível converter a string para número: ${valor}`
          );
          this.faturamentoPotencialValor = 0;
        }
      } else {
        console.log(
          `[Simulador] Aviso: Tipo de valor inesperado para faturamento potencial:`,
          typeof valor
        );
        this.faturamentoPotencialValor = 0;
      }

      console.log(
        `[Simulador] Faturamento potencial armazenado: ${
          this.faturamentoPotencialValor
        } (tipo: ${typeof this.faturamentoPotencialValor})`
      );
      console.log(
        `[Simulador] Este valor será passado para AnaliseConservadora como prop faturamentoPotencial`
      );

      // Forçar atualização de componentes que dependem deste valor
      this.$nextTick(() => {
        if (this.$refs.analiseConservadora) {
          console.log(
            "[Simulador] Forçando recálculo do faturamento conservador"
          );
          this.$refs.analiseConservadora.calcularFaturamentoConservador();
        } else {
          console.log(
            "[Simulador] Aviso: Componente analiseConservadora não encontrado"
          );

          // Tentar localizar o componente de outra forma
          const analiseComponent = this.$children.find(
            c => c.$options.name === "AnaliseConservadora"
          );
          if (analiseComponent) {
            console.log(
              "[Simulador] Componente encontrado via $children, forçando recálculo"
            );
            analiseComponent.calcularFaturamentoConservador();
          }
        }
      });
    },
    updateFaturamentoConservador(valor) {
      console.log(
        `[Simulador] Recebendo evento de faturamento conservador atualizado: ${valor} (tipo: ${typeof valor})`
      );

      // Garantir que estamos lidando com um número
      let valorNumerico = valor;
      if (typeof valor === "string") {
        valorNumerico = valor.replace(/[^\d.,]/g, "").replace(",", ".");
        valorNumerico = parseFloat(valorNumerico);
      }

      // Verificar se o valor é válido
      if (isNaN(valorNumerico)) {
        console.warn(
          `[Simulador] Valor de faturamento conservador inválido: ${valor}`
        );
        valorNumerico = 0;
      }

      console.log(
        `[Simulador] Atualizando faturamentoConservador para: ${valorNumerico}`
      );
      this.faturamentoConservadorValor = valorNumerico;

      // Forçar atualização da análise de viabilidade
      this.$nextTick(() => {
        const analiseViabilidade = this.$refs.analiseViabilidade;
        if (analiseViabilidade) {
          console.log(
            "[Simulador] Forçando recálculo na AnaliseViabilidade após atualização do faturamento conservador"
          );
          analiseViabilidade.calcularMargemContribuicao();
          analiseViabilidade.calcularLucroProjetado();
        } else {
          console.warn(
            "[Simulador] Componente analiseViabilidade não encontrado via $refs"
          );
          // Tentar encontrar via $children como fallback
          const analiseComp = this.findComponentByName(
            this.$children,
            "AnaliseViabilidade"
          );
          if (analiseComp) {
            console.log(
              "[Simulador] Componente analiseViabilidade encontrado via $children, forçando recálculo"
            );
            analiseComp.calcularMargemContribuicao();
            analiseComp.calcularLucroProjetado();
          }
        }
      });
    },
    updateDespesasFixas(valor) {
      console.log(
        `[Simulador] Recebendo evento de despesas fixas atualizadas: ${valor} (tipo: ${typeof valor})`
      );

      // Garantir que estamos lidando com um número
      let valorNumerico = valor;
      if (typeof valor === "string") {
        console.log(`[Simulador] Valor recebido é string: "${valor}"`);
        // Remover qualquer formatação não numérica
        valorNumerico = valor
          .replace(/[^\d.,]/g, "")
          .replace(/\./g, "")
          .replace(",", ".");
        valorNumerico = parseFloat(valorNumerico);
        console.log(
          `[Simulador] Valor após limpeza e conversão: ${valorNumerico}`
        );
      }

      // Verificar se o valor é válido
      if (isNaN(valorNumerico) || valorNumerico < 0) {
        console.warn(
          `[Simulador] Valor de despesas fixas inválido: ${valor} convertido para ${valorNumerico}`
        );
        valorNumerico = 0;
      }

      console.log(
        `[Simulador] Atualizando totalContasFixasValor para: ${valorNumerico}`
      );
      this.totalContasFixasValor = valorNumerico;

      // Atualizar também o valor formatado no objeto de dados
      const valorFormatado = this.formatarMoeda(valorNumerico);
      this.$set(this.dados.despesas, "totalDespesasFixas", valorFormatado);
      console.log(`[Simulador] Valor formatado atualizado: ${valorFormatado}`);

      // Forçar atualização da análise de viabilidade
      this.$nextTick(() => {
        const analiseViabilidade = this.$refs.analiseViabilidade;
        if (analiseViabilidade) {
          console.log(
            "[Simulador] Forçando recálculo na AnaliseViabilidade após atualização das despesas fixas"
          );
          analiseViabilidade.calcularLucroProjetado();
        } else {
          console.warn(
            "[Simulador] Componente analiseViabilidade não encontrado via $refs"
          );
          // Tentar encontrar via $children como fallback
          const analiseComp = this.findComponentByName(
            this.$children,
            "AnaliseViabilidade"
          );
          if (analiseComp) {
            console.log(
              "[Simulador] Componente analiseViabilidade encontrado via $children, forçando recálculo"
            );
            analiseComp.calcularLucroProjetado();
          }
        }
      });
    },
    updatePercentualDespesas(valor) {
      console.log(
        `[Simulador] Recebendo percentual de despesas atualizado: ${valor} (tipo: ${typeof valor})`
      );

      // Garantir que estamos lidando com um valor numérico
      let valorNumerico = valor;

      if (typeof valor === "string") {
        // Remover formatação e converter para número
        const valorLimpo = valor.replace(/[^\d,.]/g, "").replace(",", ".");
        valorNumerico = parseFloat(valorLimpo) || 0;
        console.log(
          `[Simulador] Valor de string convertido para número: ${valorNumerico}`
        );
      }

      // Verificar se o valor é válido
      if (isNaN(valorNumerico) || valorNumerico < 0) {
        console.warn(
          `[Simulador] Valor de percentual de despesas inválido: ${valor}`
        );
        valorNumerico = 0;
      }

      console.log(
        `[Simulador] Atualizando percentualDespesasValor para: ${valorNumerico}`
      );
      this.percentualDespesasValor = valorNumerico;

      // Atualizar também o valor formatado no objeto de dados
      const valorFormatado = valorNumerico.toFixed(2).replace(".", ",") + "%";
      this.$set(this.dados.despesas, "percentualDespesas", valorFormatado);
      console.log(
        `[Simulador] Valor formatado para dados.despesas: ${valorFormatado}`
      );

      // Atualizar o valor de despesas representadas como variável no objeto contasVariaveis
      this.$set(
        this.dados.contasVariaveis,
        "despesasRepresentadasVariavel",
        valorFormatado
      );
      console.log(
        `[Simulador] Despesas representadas como variável atualizado: ${valorFormatado}`
      );
    },
    updateTotalContasVariaveis(valor) {
      console.log(
        `[Simulador] Recebendo totalContasVariaveis: ${valor} (${typeof valor})`
      );

      // Armazenar tanto o valor numérico para cálculos quanto o formato original para exibição
      if (typeof valor === "number") {
        // Armazenar o valor numérico
        this.totalContasVariaveisValor = valor;

        // Formatar para exibição e armazenar no objeto de dados
        const valorFormatado = valor.toFixed(2).replace(".", ",") + "%";
        this.$set(
          this.dados.contasVariaveis,
          "totalContasVariaveis",
          valorFormatado
        );
        console.log(
          `[Simulador] Valor formatado para dados.contasVariaveis:`,
          valorFormatado
        );

        // Também atualizar diretamente o objeto de analiseViabilidade
        this.$set(
          this.dados.analiseViabilidade,
          "margemContribuicao",
          valorFormatado
        );
        console.log(
          `[Simulador] Valor formatado definido diretamente na margemContribuicao:`,
          valorFormatado
        );
      } else if (typeof valor === "string") {
        // Se já for uma string formatada, manter
        this.$set(this.dados.contasVariaveis, "totalContasVariaveis", valor);

        // Atualizar diretamente o objeto analiseViabilidade
        this.$set(this.dados.analiseViabilidade, "margemContribuicao", valor);
        console.log(
          `[Simulador] Valor string definido diretamente na margemContribuicao:`,
          valor
        );

        // Converter para numérico para cálculos internos
        const valorLimpo = valor.replace(/[^\d,.]/g, "").replace(",", ".");
        this.totalContasVariaveisValor = parseFloat(valorLimpo) || 0;
      }

      console.log(
        `[Simulador] Valor numérico armazenado: ${this.totalContasVariaveisValor}`
      );
      console.log(
        `[Simulador] Valor formatado armazenado: ${this.dados.contasVariaveis.totalContasVariaveis}`
      );

      // Forçar atualização do componente AnaliseViabilidade
      this.$nextTick(() => {
        if (this.$refs.analiseViabilidade) {
          console.log(
            "[Simulador] Forçando recálculo da margem de contribuição"
          );
          this.$refs.analiseViabilidade.calcularMargemContribuicao();
        }
      });
    },
    updatePercentualLucro(valor) {
      console.log(
        `[Simulador] Recebendo percentual de lucro atualizado: ${valor} (tipo: ${typeof valor})`
      );

      // Garantir que estamos lidando com um número
      let valorNumerico = valor;
      if (typeof valor === "string") {
        valorNumerico = valor.replace(/[^\d.,]/g, "").replace(",", ".");
        valorNumerico = parseFloat(valorNumerico);
      }

      if (isNaN(valorNumerico)) {
        console.warn(
          `[Simulador] Valor de percentual de lucro inválido: ${valor}`
        );
        valorNumerico = 0;
      }

      console.log(
        `[Simulador] Atualizando percentualLucro para: ${valorNumerico}`
      );
      this.percentualLucro = valorNumerico;
    },
    updateLucroProjetado(valor) {
      console.log(
        `[Simulador] Recebendo lucro projetado atualizado: ${valor} (tipo: ${typeof valor})`
      );

      // Garantir que estamos lidando com um número
      let valorNumerico = valor;
      if (typeof valor === "string") {
        valorNumerico = valor.replace(/[^\d.,]/g, "").replace(",", ".");
        valorNumerico = parseFloat(valorNumerico);
      }

      if (isNaN(valorNumerico)) {
        console.warn(`[Simulador] Valor de lucro projetado inválido: ${valor}`);
        valorNumerico = 0;
      }

      console.log(
        `[Simulador] Atualizando lucroProjetado para: ${valorNumerico}`
      );
      this.lucroProjetado = valorNumerico;

      // Verificar a viabilidade do negócio
      this.verificarViabilidade();
    },
    verificarViabilidade() {
      // Verificar se o lucro projetado é maior que o investimento
      const lucro = parseFloat(this.lucroProjetado) || 0;
      const investimento = parseFloat(this.valorInvestimentoValor) || 0;

      if (investimento > 0) {
        const tempoRetorno = investimento / lucro;
        console.log(
          `[Simulador] Tempo de retorno calculado: ${tempoRetorno.toFixed(
            2
          )} meses`
        );

        // Definir a viabilidade com base no tempo de retorno
        if (tempoRetorno <= 12) {
          console.log(
            "[Simulador] Negócio considerado VIÁVEL (retorno em até 12 meses)"
          );
          this.viabilidade = "VIÁVEL";
        } else if (tempoRetorno <= 24) {
          console.log(
            "[Simulador] Negócio considerado VIÁVEL COM RESSALVAS (retorno entre 12 e 24 meses)"
          );
          this.viabilidade = "VIÁVEL COM RESSALVAS";
        } else {
          console.log(
            "[Simulador] Negócio considerado INVIÁVEL (retorno superior a 24 meses)"
          );
          this.viabilidade = "INVIÁVEL";
        }
      } else {
        console.log(
          "[Simulador] Não é possível calcular viabilidade sem valor de investimento"
        );
        this.viabilidade = "INDEFINIDA";
      }
    },
    // Método para formatação de valores monetários
    formatarMoeda(valor) {
      if (typeof valor !== "number" || isNaN(valor)) {
        return "0,00";
      }
      return valor.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    updateInvestimentoNecessario(valor) {
      this.valorInvestimentoValor = valor;
    },
    // Método para carregar dados do localStorage
    carregarDadosLocais() {
      try {
        // Verificar qual aba estava ativa anteriormente
        const abaAtiva = localStorage.getItem("simulador_aba_ativa");
        if (abaAtiva) {
          this.activeTab = abaAtiva;
        }

        // Carregar outros dados...
      } catch (error) {
        console.error("Erro ao carregar dados salvos:", error);
      }
    },
    // Método para salvar dados no localStorage
    salvarDadosLocais() {
      try {
        // Salvar aba ativa
        localStorage.setItem("simulador_aba_ativa", this.activeTab);

        // Salvar outros dados...
      } catch (error) {
        console.error("Erro ao salvar dados:", error);
      }
    },
    findComponentByName(components, name) {
      return components.find(c => c.$options.name === name);
    }
  },
  mounted() {
    this.carregarDadosLocais();

    // Garantir que a Margem de contribuição mínima aceitável seja igual ao Total de Contas Variáveis
    this.$nextTick(() => {
      // Definir a margem de contribuição com o valor do total de contas variáveis
      this.dados.analiseViabilidade.margemContribuicao = this.dados.contasVariaveis.totalContasVariaveis;

      // Forçar atualização do componente AnaliseViabilidade
      if (this.$refs.analiseViabilidade) {
        this.$refs.analiseViabilidade.calcularMargemContribuicao();
      }
    });

    // Salvar dados automaticamente quando a página for fechada
    window.addEventListener("beforeunload", () => {
      this.salvarDadosLocais();
    });
  },
  watch: {
    activeTab(newVal, oldVal) {
      console.log(`[Simulador] Alteração de tab: ${oldVal} -> ${newVal}`);

      // Recalcular o total de pessoas com base na tab ativa
      this.totalPessoas =
        newVal === "condominio"
          ? this.condominio.entorno.totalMoradores
          : this.empresa.entorno.totalPessoas;

      console.log(
        `[Simulador] Total de pessoas atualizado: ${this.totalPessoas}`
      );

      // Atualizar os componentes relevantes
      this.$nextTick(() => {
        // Primeiro, forçar a atualização da capacidade de faturamento
        const capacidadeFaturamento = this.$refs.capacidadeFaturamento;
        if (capacidadeFaturamento) {
          console.log(
            "[Simulador] Forçando recálculo completo na CapacidadeFaturamento"
          );
          capacidadeFaturamento.recalcularTudo();
        } else {
          console.warn(
            "[Simulador] Componente capacidadeFaturamento não encontrado via $refs"
          );
          // Tentar encontrar via $children como fallback
          const capacidadeComp = this.findComponentByName(
            this.$children,
            "CapacidadeFaturamento"
          );
          if (capacidadeComp) {
            console.log(
              "[Simulador] Componente capacidadeFaturamento encontrado via $children, forçando recálculo"
            );
            capacidadeComp.recalcularTudo();
          }
        }

        // Depois, após um breve atraso, atualizar a análise conservadora
        setTimeout(() => {
          // Forçar recálculo na análise conservadora
          const analiseConservadora = this.$refs.analiseConservadora;
          if (analiseConservadora) {
            console.log(
              "[Simulador] Forçando recálculo do faturamento conservador"
            );
            analiseConservadora.calcularFaturamentoConservador();
          } else {
            console.warn(
              "[Simulador] Componente analiseConservadora não encontrado via $refs"
            );
            // Tentar encontrar via $children como fallback
            const analiseComp = this.findComponentByName(
              this.$children,
              "AnaliseConservadora"
            );
            if (analiseComp) {
              console.log(
                "[Simulador] Componente analiseConservadora encontrado via $children, forçando recálculo"
              );
              analiseComp.calcularFaturamentoConservador();
            }
          }
        }, 300);
      });
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  color: #f0512d;
  text-align: center;
  margin-bottom: 30px;
  font-size: 1.8em;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.calculator-section {
  display: none;
}

.calculator-section.active {
  display: block;
}

.logo {
  display: block;
  max-width: 120px;
  height: auto;
  margin: 0 auto 20px;
}
</style>
